import React from 'react';
import { Container, Header, Segment, Grid, Button } from 'semantic-ui-react';
import EventRegistrants from '../Components/EventRegistrants';

export default function DecadeVEvent() {
    // Form ID for Decade V event from TicketSpice
    const DECADE_V_FORM_ID = 913443;

    return (
        <Container>
            <Grid centered stackable>
                <Grid.Column width={16}>
                    <Segment>
                        <Header as="h1" textAlign="center">
                            Decade V Reunion Weekend
                            <Header.Subheader>
                                Nov 6-8, 2026
                            </Header.Subheader>
                        </Header>

                        <Segment color="green" textAlign="center">
                            <p style={{ fontSize: '1.1em', marginBottom: '1.5em' }}>
                                This special event brings together Lambda Phi alums from across the decades
                                to reconnect and celebrate our chapter. </p>
                            <p style={{ fontSize: '1.1em', marginBottom: '1.5em' }}> More information is available on the registration site:</p>
                            <Button
                                as="a"
                                href="https://lambdaphi.ticketspice.com/decade-v-reunion"
                                target="_blank"
                                rel="noopener noreferrer"
                                size="large"
                                color="green"
                                icon="ticket"
                                content="Register Now"
                            />
                        </Segment>

                        <EventRegistrants
                            formId={DECADE_V_FORM_ID}
                            eventName="Decade V"
                            attendeeTerm="RSVP"
                        />
                    </Segment>
                </Grid.Column>
            </Grid>
        </Container>
    );
}
